export const loadStripe = () => {
  if (process.env.NODE_ENV === 'production') {
    window.stripe = window.Stripe('pk_live_s5XYTfGGqA1JUX47bHGsKghN')
  } else {
    window.stripe = window.Stripe('pk_test_CcuJvFr1lQxFKMrdZn0GzYIS')
  }
}

export const ensureStripeLoaded = (callback) => {
  const interval = setInterval(() => {
    if (!window.stripe && window.Stripe) {
      loadStripe(callback)
    } else {
      clearInterval(interval)
      if (callback) callback()
    }
  }, 1000)

  return interval
}



// WEBPACK FOOTER //
// client/stripe.js